import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UMAMI_WEBSITE_ID = '14146739-d6a5-4dfd-a048-c72cf4fff249';
const UMAMI_SCRIPT_URL = 'https://umami.bitstack.website/script.js';

// Initialize Umami (call this once at app startup)
export const initUmami = () => {
  // Check if script already exists
  const existingScript = document.querySelector(`script[src="${UMAMI_SCRIPT_URL}"]`);
  
  if (!existingScript) {
    // Add Umami script dynamically
    const script = document.createElement('script');
    script.src = UMAMI_SCRIPT_URL;
    script.defer = true;
    script.setAttribute('data-website-id', UMAMI_WEBSITE_ID);
    document.head.appendChild(script);
  }
};

// Hook to track page views (use inside Router context)
export const useUmamiTracker = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    // Give the script time to load on first render
    const timer = setTimeout(() => {
      if (window.umami) {
        window.umami.track('pageview');
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Custom event tracking function (optional - for future use)
  const trackEvent = (eventName, eventData = {}) => {
    if (window.umami) {
      window.umami.track(eventName, eventData);
    }
  };

  return { trackEvent };
};